import script from "./MysticalArrival.vue?vue&type=script&setup=true&lang=js"
export * from "./MysticalArrival.vue?vue&type=script&setup=true&lang=js"

import "./MysticalArrival.vue?vue&type=style&index=0&id=9f8f15a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f8f15a2"]])

export default __exports__